import './Login.css';
import React, {Fragment, useEffect, useRef, useState} from "react";
import Svg from "../../Components/SvgClock/Svg";
import axios from "axios";
import {Navigate, useNavigate} from "react-router-dom";
// import Cort from 'src/Pages/Login/cort_grey.svg';
import { isMobile } from 'react-device-detect';
import InputMask from 'react-input-mask';
import toast, { Toaster } from 'react-hot-toast';
import RegisterAccept from "../Registration/RegisterAccept/RegisterAccept";
import RestorePassword from "./RestorePassword/RestorePassword";
import RegisterCode from "../Registration/RegisterCode/RegisterCode";

function Login() {

    const navigate = useNavigate();
    const [phone, setPhone] = useState('');
    const [phoneError, setPhoneError] = useState(null);
    const [loginError, setLoginError] = useState(null);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isPhoneValid, setIsPhoneValid] = useState(false);
    const [isRestoreModalOpen, setIsRestoreModalOpen] = useState(false);

    const [pinOpen, setPinOpen] = useState(false);


    const onChangePhone = (e) => {
        setPhone(e.target.value);
        // console.log(phone.replace(/\D/g, ''));
    }

    const togglePasswordVisibility = () => {
        setIsPasswordVisible((prev) => !prev);
    };

    const checkPhone = () => {

        let data = {};
        // if (phone.replace(/\D/g, '') !== '') {
        //     data['phone_number'] = '+' + phone.replace(/\D/g, '');
        // }

        data['email'] = phone;


        let statusResponse;

        // e.preventDefault();

        axios.post(`/api/check-phone/`, data, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                console.log(res.status);
                statusResponse = res.status;
                console.log(statusResponse);
                if (statusResponse === 200) {
                    setIsPhoneValid(true);
                    // navigate("/reserve", {replace: true});
                    // setLoggedIn(true);
                } else {
                    console.log('Неправильный email или пароль');
                    // alert('Неправильные данные');
                    // toast.error("Неверные данные");
                    return <Navigate to={'/login'} replace />
                }
                if (statusResponse === 401) {
                    // alert('Неправильные данные');
                    // toast.error("Неверные данные");
                    return <Navigate to={'/login'} replace />
                }
            })
            .catch(e => {
                // setIsPhoneValid(true); // убрать
                console.log(e);
                // alert('Неправильные данные');
                // toast.error("Неверные данные");
                if (e.status === 404 || e.status === 500 || e.code === 'ERR_NETWORK') {
                    setPhoneError('Неполадки сети, попробуйте позже');
                } else if (e.response?.data.detail) {
                    setPhoneError(e.response.data.detail);
                    // if (e.response?.data.errors["phone_number"] !== undefined) {
                    //     console.log(e.response.data.errors["phone_number"]);
                    //     // toast.error(e.response.data.errors['password1'][0], {
                    //     //     duration: 5000,
                    //     // });
                    //     // setRegisterError(e.response.data.errors['password1'][0]);
                    //     setPhoneError('Проверьте телефон');
                    // }
                    // if(e.response?.data.errors["auth_error"] !== undefined) {
                    //     console.log(e.response.data.errors["auth_error"]);
                    //     // toast.error(e.response.data.errors['password1'][0], {
                    //     //     duration: 5000,
                    //     // });
                    //     // setRegisterError(e.response.data.errors['password1'][0]);
                    //     setLoginError('Проверьте данные');
                    // }
                    // setLoginError('Проверьте данные');
                }
            })
    }

    const loginUser = (e) => {

        let data = {};
        // data['phone_number'] = '+' + phone.replace(/\D/g, '');
        data['email'] = phone;
        data['password'] = document.getElementById('login-pass').value;

        let statusResponse;

        e.preventDefault();

        // axios.post(`${process.env.REACT_APP_HOST || ''}/api/login/`, data, {headers: {
        axios.post(`/api/login/`, data, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                console.log(res.status);
                statusResponse = res.status;
                console.log(statusResponse);
                if (statusResponse === 200) {
                    navigate("/profile", {replace: true});
                    // setLoggedIn(true);
                } else {
                    console.log('Неправильный email или пароль');
                    // alert('Неправильные данные');
                    // toast.error("Неверные данные");
                    return <Navigate to={'/login'} replace />
                }
                if (statusResponse === 401) {
                    // alert('Неправильные данные');
                    // toast.error("Неверные данные");
                    return <Navigate to={'/login'} replace />
                }
            })
            .catch(e => {
                console.log(e);
                // alert('Неправильные данные');
                // toast.error("Неверные данные");
                if (e.status === 404 || e.status === 500 || e.code === 'ERR_NETWORK') {
                    setLoginError('Неполадки сети, попробуйте позже');
                } else if (e.status === 418) {
                    // setLoginError('Почта не подтверждена');
                    setPinOpen(true);
                } else if (e.response?.data.errors) {
                    if (e.response?.data.errors["phone_number"] !== undefined) {
                        console.log(e.response.data.errors["phone_number"]);
                        // toast.error(e.response.data.errors['password1'][0], {
                        //     duration: 5000,
                        // });
                        // setRegisterError(e.response.data.errors['password1'][0]);
                        setLoginError('Проверьте почту');
                    }
                    if (e.response?.data.errors["auth_error"] !== undefined) {
                        console.log(e.response.data.errors["auth_error"]);
                        // toast.error(e.response.data.errors['password1'][0], {
                        //     duration: 5000,
                        // });
                        // setRegisterError(e.response.data.errors['password1'][0]);
                        // setLoginError('Проверьте данные');
                        setLoginError(e.response.data.errors["auth_error"]);
                    }
                    // setLoginError('Проверьте данные');
                }
            })

    }

    const restorePassword = () => {

    }

    const openRestoreModal = () => {
        setIsRestoreModalOpen(true);
    }

    const backToPhoneSelection = () => {
        setIsPhoneValid(false);
        setPhoneError(null);
        setLoginError(null);
        document.getElementById('login-pass').value = '';
    }

    const goToRegister = () => {
        navigate('/register');
    }

    const loginYandex = () => {

        window.location.href = '/api/auth/yandex/login/';

    }

    const loginVK = () => {

        window.location.href = '/api/auth/vk/login/';

    }

    const loginMail = () => {

        window.location.href = '/api/auth/mail/login/';

    }

    return (
        <div className={'login-page-no-background'}>

            <div className={'login-name-logo'}>
                <svg version="1.1" id="login-name-logo-svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                     viewBox="0 0 821.17 213.52">
                    <g>
                        <path fill="#CECCCC" d="M59.24,155.51l-13.03,13.03v42.24H0V0h46.21v111.9l4.66-6.17L85.71,62.4h55.4l-51.97,61.03l55.4,87.36
                            H91.61L59.24,155.51z"/>
                        <path fill="#CECCCC" d="M147.42,135.22c0-14.81,2.88-28,8.64-39.56c5.76-11.56,14.03-20.45,24.82-26.67
                            c10.79-6.22,23.45-9.33,37.99-9.33c22.22,0,39.72,6.88,52.52,20.64c12.8,13.76,19.2,32.48,19.2,56.16v1.65
                            c0,23.13-6.42,41.48-19.27,55.06c-12.85,13.58-30.24,20.36-52.18,20.36c-21.12,0-38.08-6.33-50.88-18.99
                            c-12.8-12.66-19.7-29.83-20.71-51.49L147.42,135.22z M193.64,138.1c0,13.71,2.15,23.77,6.45,30.17c4.3,6.4,10.65,9.6,19.06,9.6
                            c16.46,0,24.87-12.66,25.23-37.99v-4.66c0-26.6-8.5-39.91-25.51-39.91c-15.45,0-23.82,11.47-25.1,34.42L193.64,138.1z"/>
                        <path fill="#CECCCC" d="M400.71,104.22l-15.22-1.1c-14.54,0-23.86,4.57-27.98,13.71v93.94H311.3V62.4h43.34l1.51,19.06
                            c7.77-14.54,18.6-21.8,32.5-21.8c4.94,0,9.23,0.55,12.89,1.65L400.71,104.22z"/>
                        <path fill="#CECCCC" d="M478.06,25.51V62.4h24.41v32.09h-24.41v67.88c0,5.58,1,9.46,3.02,11.66c2.01,2.19,5.99,3.29,11.93,3.29
                            c4.57,0,8.41-0.27,11.52-0.82v33.05c-8.32,2.65-17,3.98-26.06,3.98c-15.91,0-27.66-3.75-35.24-11.25
                            c-7.59-7.5-11.38-18.88-11.38-34.15V94.49h-18.92V62.4h18.92V25.51H478.06z"/>
                        <path fill="#CECCCC" d="M641.93,132.75h20.3v35.66h-20.3v42.38h-46.21V168.4h-77.21l-2.74-28.25l79.95-128.63v-0.41h46.21V132.75z
                             M559.79,132.75h35.93V71.31l-2.88,4.66L559.79,132.75z"/>
                        <path fill="#CECCCC" d="M821.17,129.18c0,26.97-6.06,47.77-18.17,62.4c-12.12,14.63-29.19,21.94-51.22,21.94
                            c-22.22,0-39.41-7.36-51.56-22.08c-12.16-14.72-18.24-35.47-18.24-62.26V92.7c0-26.97,6.06-47.77,18.17-62.4
                            c12.11-14.63,29.23-21.94,51.36-21.94c22.12,0,39.27,7.36,51.43,22.08c12.16,14.72,18.24,35.52,18.24,62.4V129.18z M774.96,86.81
                            c0-14.35-1.88-25.07-5.62-32.16c-3.75-7.08-9.69-10.63-17.83-10.63c-7.95,0-13.74,3.29-17.35,9.87c-3.61,6.58-5.55,16.55-5.83,29.9
                            v51.02c0,14.9,1.87,25.8,5.62,32.71c3.75,6.9,9.69,10.35,17.83,10.35c7.86,0,13.67-3.36,17.42-10.08
                            c3.75-6.72,5.67-17.26,5.76-31.61V86.81z"/>
                    </g>
                </svg>

            </div>

            <div className={'login-circle-logo'}></div>

            <form onSubmit={(e) => loginUser(e)} className={'login-form'}>
                {!isPhoneValid &&
                    (<Fragment>
                        <div className={'login-form-input'}>
                            <p className={'login-input-login-label'}>Почта</p>
                            {/*<input type={'text'} id={'login-phone'} className={'login-input-login-input'} required />*/}
                            <input type={'text'} className={'login-input-login-input'} value={phone} onChange={onChangePhone} placeholder={'Ваша почта...'} required />
                            {/*<InputMask*/}
                            {/*    className={'login-input-login-input'}*/}
                            {/*    mask="+7 (999) 999-99-99"*/}
                            {/*    value={phone}*/}
                            {/*    onChange={onChangePhone}*/}
                            {/*    placeholder={'Ваш номер...'}*/}
                            {/*    required*/}
                            {/*/>*/}
                        </div>
                        {/*<div className={'login-form-input'}>*/}
                        {/*    <p className={'login-input-pwd-label'}>Пароль</p>*/}
                        {/*    <div className={'password-login'}>*/}
                        {/*        <input*/}
                        {/*            type={isPasswordVisible ? 'text' : 'password'}*/}
                        {/*            id={'login-pass'}*/}
                        {/*            className={'login-input-pwd-input'}*/}
                        {/*            placeholder={'Не менее 8 символов'}*/}
                        {/*            required*/}
                        {/*        />*/}
                        {/*        <a*/}
                        {/*            href="#"*/}
                        {/*            className={`password-control-login ${isPasswordVisible ? 'view' : ''}`}*/}
                        {/*            onClick={(e) => {*/}
                        {/*                e.preventDefault();*/}
                        {/*                togglePasswordVisibility();*/}
                        {/*            }}*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className={'login-error-block'}>{phoneError !== null ? phoneError : ''}</div>
                        <div className={'login-submit-block'}>
                            <input type={'button'} value={'Далее >>'} className={'login-submit-button'}
                                   onClick={() => checkPhone()}/>
                        </div>
                        <div className={'login-register-block'}>
                            <input type={'button'} value={'Регистрация'} className={'login-register-button'}
                                   onClick={() => goToRegister()}/>
                        </div>
                        <div className={'login-form-footer'}>
                            <p className={'login-form-footer-text'}>или войти через:</p>
                            <div className={'login-form-footer-services'}>
                                <div className={'login-other-service login-vk'} onClick={() => loginVK()}></div>
                                <div className={'login-other-service login-ya'} onClick={() => loginYandex()}></div>
                                {/*<div className={'login-other-service login-mail'} onClick={() => loginMail()}></div>*/}
                            </div>
                        </div>
                    </Fragment>)}

                {isPhoneValid &&
                    (<Fragment>
                        <div className={'login-form-input'}>
                            <p className={'login-input-pwd-label'}>Пароль</p>
                            <div className={'password-login'}>
                                <input
                                    type={isPasswordVisible ? 'text' : 'password'}
                                    id={'login-pass'}
                                    className={'login-input-pwd-input'}
                                    placeholder={'Ваш пароль...'}
                                    required
                                />
                                <a
                                    href="#"
                                    className={`password-control-login ${isPasswordVisible ? 'view' : ''}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        togglePasswordVisibility();
                                    }}
                                />
                            </div>
                        </div>
                        <div className={'login-error-block'}>{loginError !== null ? loginError : ''}</div>
                        <div className={'login-submit-block'}>
                            <input type={'submit'} value={'Вход >>'} className={'login-submit-button'}/>
                        </div>
                        <div className={'login-back-to-phone-button'} onClick={() => backToPhoneSelection()}>
                            назад
                        </div>
                        <div className={'login-form-pwd-footer-text'}>
                            <p className={'login-form-footer-text'}>Если забыли пароль, то можно:</p>
                        </div>
                        <div className={'login-restore-block'}>
                            <input type={'button'} value={'Восстановить'} className={'login-register-button'}
                                   onClick={openRestoreModal}/>
                        </div>
                    </Fragment>)}

            </form>

            <RestorePassword
                isOpen={isRestoreModalOpen}
                onRequestClose={setIsRestoreModalOpen}
                email={phone}
            />

            {pinOpen && <RegisterCode email={phone} isModalOpen={setPinOpen} />}

        </div>
    );
}

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export default Login;
